<template>
    <div class="vertical grow gallery-container" style="width: 70vw; height: 100%">
        <div class="two-columns-template-modal" style="margin-top: 5px;">
            <div class="scrollbar-full" style="max-height: 70vh; overflow: auto;">
                <div v-if="(visit == null && existingElement == null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Visit') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <select v-model="selectedObject.visitId" @change="visitChanged">
                                <option v-for="v in visits" :key="v.id" :value="v.id">
                                    {{v.farmName}} ({{v.mainAssigneeName}}) ({{moment(v.dateFrom).format('DD-MM-YYYY')}} - {{moment(v.dateTo).format('DD-MM-YYYY')}})
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div v-else class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Visit') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{visitShown.farmName}} ({{visitShown.mainAssigneeName}}) ({{moment(visitShown.createDate).format('YYYY-MM-DD')}} - {{moment(visitShown.resolveDate).format('YYYY-MM-DD')}})</span>
                        </td>
                    </tr>
                </div>

                <div v-if="(existingElement == null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Problem') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <select v-model="selectedObject.problemId" >
                                <option v-for="p in problems" :key="p.id" :value="p.id">
                                    {{p.title}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div v-else class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Problem') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{existingElement.problemTitle}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Notes') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <textarea v-model="selectedObject.description" type="text"/>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('WorkDone') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <textarea v-model="selectedObject.workDone" type="text"/>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('RequiredSpareParts') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <textarea v-model="selectedObject.requiredSpareParts" type="text"/>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('SystemStatus') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <!-- <input v-model="selectedObject.systemStatusCheck" type="text"/> -->
                            <select v-model="selectedObject.systemStatusCheck" >
                                <option v-for="p in systemStatusEnum" :key="p.id" :value="p.id">
                                    {{p.name}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('FurtherWork') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <textarea v-model="selectedObject.furtherWork" type="text"/>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('ResolvedDate') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <date-picker :confirm="false" v-model="selectedObject.resolveDate" :type="'date'" :clearable="false" :format="'DD-MM-YYYY'"></date-picker>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Photos') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <input type="file" id="problemPhotoId" name="problemPhoto" accept="image/*" @change.prevent="addPhoto" multiple>
                        </td>
                    </tr>
                </div>

                <div>
                    <div class="error" v-if="error != ''">{{ error }}</div>
                </div>
            </div>
            <div style="background-color: rgba(243, 243, 243, 1)">
                <div id="photos-container" style="margin: auto;">
                    <div class="vertical" style="margin: auto;">
                        <div style="width: calc(0.5 * 70vw); height: 50vh; align-self: center; text-align: center; overflow: hidden; white-space: nowrap;" v-if="(photos.length > 0)">
                            <i class="arrow left" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(-1)"></i>
                            <img class="photo" :src="photos[activePhotoIndex].url" >
                            <i class="arrow right" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(1)"></i>
                        </div>
                        <div class="thumbnails horizontal">
                            <div v-for="(photo, index) in photos" :key="index" @click="activePhotoIndex = index">
                                <div class="thumbnail-container">
                                    <img class="delete-image" src="~@/assets/img/Visits/Delete.svg" @click="deletePhoto(index)">
                                    <img :src="photo.url" class="thumbnail" v-bind:class="{ selectedThumbnail: activePhotoIndex == index}"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="align-self: center; margin-bottom: 20px;">
            <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Button from '@/components/Button.vue';
import { getActiveOrFutureVisitsNames, getActiveProblemsForVisit, saveSolution, editSolution, getSolution, deleteResourceFromSolution, getVisit, getSolutionResourceById } from '@/api/api';
import moment from 'moment'
// todo add problem prop
export default {
    props: {
        existingElement: {
            required: false,
            type: Object,
            default: null
        },
        visit: {
            required: false,
            type: Object,
            default: null
        },
        onlyShow: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    components: {
        DatePicker,
        Button
    },
    data() {
        return {
            selectedObject: {
                visitId: null,
                problemId: null,
                creatorId: null,
                description: '',
                workDone: '',
                requiredSpareParts: '',
                systemStatusCheck: 'Incomplete',
                furtherWork: '',
                createDate: moment(Date.now()),
                resolveDate: null,
            },
            visitShown: {
                farmName: '',
                mainAssigneeName: '',
                createDate: null,
                resolveDate: null,
            },

            error: '',
            visits: [],
            problems: [],
            photos: [],
            activePhotoIndex: 0,
            systemStatusEnum: [
                {name: this.$t("Complete"), id: "Complete"},
                {name: this.$t("Incomplete"), id: "Incomplete"},
                {name: this.$t("Pending For Spares"), id: "PendingForSpares"},
                {name: this.$t("Under Observation"), id: "UnderObservation"}
            ]
        }
    },
    methods: {
        async getData() {
            if (this.visit != null) {
                this.visitShown = Object.assign({}, this.visit)
                this.selectedObject.visitId = this.visit.id
                this.visitChanged()
                // return;
            }

            if (this.existingElement != null) {
                this.selectedObject = await getSolution(this.existingElement.id)
                if (!this.systemStatusEnum.map(x => x.id).includes(this.selectedObject.systemStatusCheck)) {
                    this.selectedObject.systemStatusCheck = "Incomplete"
                }
                this.selectedObject.resolveDate = new Date(this.selectedObject.resolveDate)

                this.visitShown = await getVisit(this.selectedObject.visitId)
                this.visitChanged();

                for (let i = 0; i < this.selectedObject.resources.length; i++) {
                    let img = await getSolutionResourceById(this.selectedObject.resources[i]);
                    let photo = URL.createObjectURL(
                        new Blob([img.data], {
                                    type: img.headers['content-type']
                                })
                    );

                    this.photos.push({
                        src: img,
                        url: photo,
                        id: this.selectedObject.resources[i]
                    });
                }

                return;
            }

            var result = await getActiveOrFutureVisitsNames()
            this.visits = result;
        },
        async save() {
            this.validate()

            if(this.error != '') {
                return
            }

            if(this.existingElement != null) {
                this.edit();
                return;
            }

            var toSend = Object.assign({}, this.selectedObject)
            toSend.createDate = moment(Date.now()).format('YYYY-MM-DD')
            toSend.resolveDate = moment(toSend.resolveDate).format('YYYY-MM-DD')
            toSend.creatorId = this.$store.getters.user.userId

            var form = new FormData()
            var keys = Object.keys(toSend)
            for(let i = 0; i < keys.length; i++){
                form.append(keys[i], toSend[keys[i]])
            }

            var photosSrc = this.photos.map(x => x.src)
            for(let i = 0; i < photosSrc.length; i++) {
                form.append("resources", photosSrc[i])
            }

            await saveSolution(form)
            this.$emit('saved')
        },
        async edit() {
            var toSend = Object.assign({}, this.selectedObject)
            toSend.resolveDate = moment(this.selectedObject.resolveDate).format('YYYY-MM-DD')
            toSend.createDate = moment(this.selectedObject.createDate).format('YYYY-MM-DD')

            var form = new FormData()
            var keys = Object.keys(toSend)
            for(let i = 0; i < keys.length; i++){
                form.append(keys[i], toSend[keys[i]])
            }

            var photosSrc = this.photos.filter(x => x.id == undefined).map(x => x.src)
            for(let i = 0; i < photosSrc.length; i++) {
                form.append("resources", photosSrc[i])
            }

            await editSolution(form)

            var existingPhotosIds = this.photos.filter(x => x.id != undefined).map(x => x.id);
            var photosToDelete = this.existingElement.resourcesId.filter(x => !existingPhotosIds.includes(x))

            for(let i = 0; i < photosToDelete.length; i++) {
                await deleteResourceFromSolution(photosToDelete[i]);
            }

            this.$emit('saved')
        },
        async visitChanged() {
            this.problems = await getActiveProblemsForVisit(this.selectedObject.visitId)
        },
        deletePhoto(index) {
            this.activePhotoIndex = this.activePhotoIndex == index ? index > 1 ? index - 1 : 0 : this.activePhotoIndex;
            this.photos.splice(index, 1);
        },
        changePhoto(direction){
            if(direction > 0){
                if (this.activePhotoIndex + 1 < this.photos.length) {
                    this.activePhotoIndex++;
                } else {
                    this.activePhotoIndex = 0;
                }
            } else {
                if (this.activePhotoIndex > 0) {
                    this.activePhotoIndex--;
                } else {
                    this.activePhotoIndex = this.photos.length - 1
                }
            }
        },
        addPhoto(e){
            for(let i = 0; i < e.target.files.length; i++ ) {
                var photo = URL.createObjectURL(e.target.files[i]);
                this.photos.push({
                    src: e.target.files[i],
                    url: photo
                });
            }
            this.activePhotoIndex = this.photos.length - 1
        },
        validate() {
            this.error = ''

            if(this.existingElement == null) {

                if (!this.visits.map(x => x.id).includes(this.selectedObject.visitId)) {
                    this.error = 'Select visit and problem before saving.'
                    return
                }

                if (!this.problems.map(x => x.id).includes(this.selectedObject.problemId)) {
                    this.error = 'Select problem before saving.'
                    return
                }
            }

            if(this.selectedObject.description == null || this.selectedObject.description.trim() == '') {
                this.error = 'Write description before saving.'
                return
            }

            if(this.selectedObject.workDone == null || this.selectedObject.workDone.trim() == '') {
                this.error = 'Write what was done before saving.'
                return
            }

            if(this.selectedObject.requiredSpareParts == null || this.selectedObject.requiredSpareParts.trim() == '') {
                this.selectedObject.requiredSpareParts = '-'
            }

            if (this.selectedObject.furtherWork == null || this.selectedObject.furtherWork.trim() == '') {
                this.selectedObject.furtherWork = '-'
            }

            if (this.selectedObject.resolveDate == null) {
                this.selectedObject.resolveDate = moment(new Date("0001-01-01T00:00:00+00:00")).format('YYYY-MM-DD')
            }
        }
    },
    async mounted() {
        this.getData()
    }
}
</script>

<style scoped>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

textarea, input[type="text"] {
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.scrollbar-full {
    overflow-y: auto;
    overflow-x: hidden;
}

.scrollbar-full::-webkit-scrollbar-track
{
    border: 1px solid #A3D4E0;
	-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.3);
	border-radius: 3px;
	background-color: white;
}

.scrollbar-full::-webkit-scrollbar
{
	width: 10px;
	background-color: white;
}

.scrollbar-full::-webkit-scrollbar-thumb
{
	border-radius: 3px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: rgb(0, 149, 178);
}
</style>



// WEBPACK FOOTER //
// src/components/Visits/Solutions/SolutionModal.vue